import React, { useEffect, useState } from 'react'
import './formationDetailCard.css'
import logger from '../../../../utils/logger'
import { getStateInfo } from '../../../../helper/stateTranslate'
import ReactBootstrapModal from '../../../common/modals/ReactBootstrapModal'
import { FormationAlert } from '../../../common/Alerts/formations/FormationAlert'
import { useSelector } from 'react-redux'
import { BottomSheetBeta } from '../../../common/bottom-sheet/BottomSheetBeta'
import { BottomSheetAnimate } from '../../../common/bottom-sheet-animate/BottomSheetAnimate'
import { UserDetailModal } from '../../../common/userDetailModal/UserDetailModal'


export const FormationDetailCard = ({ member, stateModel, memberActions, FormationId, refetch, mode ,validateAddition}) => {

    const list = useSelector((data) => data.commonData.lista?.professions)

    const isInfoMode = mode === "info";

    const getProfession = (id) => {

        if (!list) return;

        const userProfession = list.find(p => p.id === id);


        return userProfession?.name;
    }



    //? Setea el tipo de Modal que se visializara ALERT 
    const [bootstrapModalStatus, setBootstrapModalStatus] = useState(null);

    const closeBootstrapModal = () => {

        setBootstrapModalStatus(null);
    }



    const handleShow = (item) => {
        setBootstrapModalStatus(item)
    };



    //?



    const [selectedAction, setSelectedAction] = useState(null)
    const [selectedMember, setSelectedMember] = useState(null)
    const [selecteContent, setSelectedContent] = useState(null)



    const resolveActions = (member) => {
        const actions = [];

        if (!isInfoMode) {

            if (member.dueAmount > 0 && memberActions?.PAY) {
                actions.push(memberActions.PAY)
            }

            if (member.isActive) {

                if (memberActions?.DELETE) {
                    actions.push(memberActions.DELETE)
                }
            } else {

                if (memberActions?.ADD) {
                    actions.push(memberActions.ADD)
                }
            }
        }


        if (memberActions?.VIEW) {
            actions.push(memberActions.VIEW);
        }

        return actions;
    };


    const onActionClick = (action, member) => {

        logger.debug('action: ', action)
        logger.debug('member: ', member)
        setSelectedAction(action)
        setSelectedMember(member)

        if (action.apiKey) {

            handleShow('alert')


        } else {
            handleShow('userDetail')

        }
    }

    useEffect(() => {

        if (selectedAction && selectedMember) {

            setSelectedContent({
                title: selectedAction.title,
                verb: selectedAction.verb,
                btnTitle: selectedAction.btnTitle,
                email: selectedMember.email
            })
        }


    }, [selectedAction, selectedMember])




    logger.debug('content: ', selecteContent)

    const getInitialsName = (nombreCompleto = "") => {

        const palabra = nombreCompleto.trim().split(/\s+/)[0]

        if (!palabra) return "";
        return palabra[0].toUpperCase();
    }
    const getInitialsLastname = (nombreCompleto = "") => {
     
        const palabras = nombreCompleto.trim().split(/\s+/);

      
        if (palabras.length === 0 || palabras[0] === "") return "";

    
        const ultimaPalabra = palabras[palabras.length - 1];

     
        return ultimaPalabra[0].toUpperCase();
    };


    const getInitials = (name, lastName) => {

        const userName = getInitialsName(name)
        const userLastName = getInitialsLastname(lastName)

        return `${userName}${userLastName}`
    }


    const stateToTranslate = (state) => {
        if (member) {

            const getState = getStateInfo(stateModel, state)
            logger.info('status translationStatus: ', getState)

            return getState
        }
    }


    //? bottom Sheet State

    const [BottomSheet, setBottomSheet] = useState(false);

    const openBottomSheet = () => setBottomSheet(true)


    const closeBottomSheet = () => {

        setBottomSheet(false)

    }

    const isMobile = window.matchMedia('(max-width: 767px)').matches;

    const onCardClick = () => {
        logger.debug('onCardClick')

        if (isMobile) return;
        if (bootstrapModalStatus) return;
        if (BottomSheet) return;


        setSelectedAction(null);
        setSelectedMember(member);
        handleShow('userDetail');
    }


    return (
        <div className='formation-detail-card d-flex' onClick={onCardClick}>

            <div className='fd-acronyms-container'>
                <span className={`fd-acronyms ${member.isActive ? 'fda-member' : 'fda-no-member'}`}>
                    {getInitials(`${member.name}`, `${member.lastname}`)}
                </span>
            </div>

            <div className='fd-card-references'>

                <div className='fdc-user-profile d-flex'>

                    <div className='fdc-username'>

                        <span className='fdc-name'>{member.fullName}</span>



                    </div>

                    {!isInfoMode &&
                        <>
                                <div className={`fdc-status span-${member?.state.toLowerCase()} fdc-responsive-status-span`}>
                                    <span>{stateToTranslate(member?.state).stateString}</span>
                                </div>

                                <div className={`fdc-status span-${member?.state.toLowerCase()} fdc-responsive-status`}>

                                </div>
                        </>
                    }
                    

                </div>

                <div className='fdc-data-container'>

                    <div className='fdc-data'>

                        <span className='fdc-dni'>{`DNI: ${member.dni}`}</span>

                        <div className='fdc-location-profession-container'>
                            <span className='fdc-email'>{getProfession(member.professionId
                            )}</span>
                            <span className='fdc-phone'>{`${member.city}, ${member.province}`}</span>
                        </div>


                    </div>


                    {!isInfoMode &&
                        <div className="fdc-actions">
                            <div className={`fdc-action-btn d-flex align-items-center
    ${member.dueAmount > 0 ? 'justify-content-between' : 'justify-content-end'}
  `}>
                                {resolveActions(member).map(action => (
                                    <span
                                        key={action?.id}
                                        className={`material-symbols-outlined fdc-actions-class ${action?.className}`}
                                        aria-hidden="true" role="none"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onActionClick(action, member);
                                        }}
                                    >
                                        {action?.icon}
                                    </span>
                                ))}
                            </div>
                        </div>
                    }


                </div>

            </div>

            <div
                className="dropdown-container"
                onClick={(e) => {
                    e.stopPropagation();
                    openBottomSheet();
                }}
            >
                <span>...</span>
            </div>



            <BottomSheetAnimate
                bottomSheetStatus={BottomSheet}
                closeBottomSheet={closeBottomSheet}
            >

                <div className='fdc-bottom-sheet-container'>

                    <span className='fdc-name bs-name mb-3'>{member.fullName}</span>


                    <div className='fdc-bs-actions-container'>

                        {resolveActions(member).map(action => (

                            <div
                                className='fdc-bs-wrapper '
                                role="button"
                                key={action?.id}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    closeBottomSheet();

                                    setTimeout(() => {
                                        onActionClick(action, member);
                                    }, 400);
                                }}
                            >

                                <div className='fdc-wrapper-icon me-2 '>

                                    <span
                                        className={`material-symbols-outlined  ${action?.mobileClassName}`}
                                        aria-hidden="true" role="none"
                                    >
                                        {action?.icon}
                                    </span>

                                </div>


                                <span className='fdc-bs-wrapper-label' >
                                    {action?.label}
                                </span>

                            </div>

                        ))}

                    </div>


                </div>
            </BottomSheetAnimate>





            <ReactBootstrapModal
                toggleModal={closeBootstrapModal}
                showModal={bootstrapModalStatus}
                modalClass={bootstrapModalStatus === 'alert' ? 'modalAlert' : 'fc-modalInfo'}
                dialogClass={'formation-dialogClass'}


            >

                {bootstrapModalStatus === 'alert' ?

                    <FormationAlert
                        closeBootstrapModal={closeBootstrapModal}
                        selectedAction={selectedAction}
                        selectedMember={selectedMember}
                        FormationId={FormationId}
                        refetch={refetch}
                        validateAddition={validateAddition}
                    />

                    :

                    bootstrapModalStatus === 'userDetail' ?

                        <UserDetailModal
                            userData={member}
                            toggleModal={closeBootstrapModal}
                        />

                        :
                        null
                }




            </ReactBootstrapModal>


        </div>


    )
}
